var new_date = new Date(
  new Date().setDate(new Date().getDate() + 30)
).toLocaleDateString('de');
const siteTitle = 'Bestellung abschließen';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Geben Sie Ihre Informationen ein',
    formTitle2: 'Eine Bestellung aufgeben',
    btnForm: 'Continua',
    btnForm2: 'Zahlen',
    priceText1: 'Zahlung',
    priceText2: 'Insgesamt',
    footerTitle: 'Online bezahlen',
    footerText: 'Bestätigen Sie mit Ihrer Kreditkarte',
    shippingInfoText: 'Versand- und Rechnungsinformationen',
    paymentInfoText: 'ZAHLUNGSINFORMATIONEN',
    agreengText:
      'Indem ich auf „Weiter“ klicke, bestätige ich, dass ich die Allgemeinen Geschäftsbedingungen, die Datenschutzrichtlinie gelesen, zugestimmt und akzeptiert habe und dass ich mindestens 18 Jahre alt bin.',
    checkboxText:
      'Ich stimme zu, Newsletter-Benachrichtigungen, Angebote und Kommunikationsdienste zu erhalten.',
    bigFooterText: `Dank Ihrer Mitgliedschaft nehmen Sie auch an unserem Wettbewerb teil, um den ${siteTitle} zu gewinnen. Unter jeweils 600 Teilnehmern ermitteln wir einen Gewinner. Der nächste Gewinner wird am ${new_date} ausgewählt und direkt per E-Mail benachrichtigt. Sollte die Prämie nicht vorrätig sein, erhält der Gewinner stattdessen ein ähnliches Produkt mit gleichem oder höherem Wert.`,
    bigFooterText1: `Wir stellen sicher, dass unsere Mitglieder eine detaillierte Historie der Transaktionen erhalten und sie dadurch wissen, wofür sie bezahlen.“ Kreditkarteninformationen werden nur benötigt, um zukünftige Einkäufe zu erleichtern. Auf Ihrer Kreditkartenabrechnung werden keine Gebühren erhoben, wenn Sie nicht auf die PREMIUM-Mitgliedschaft upgraden und keinen Kauf tätigen.`,
    bigFooterText2: `Wenn Sie diesem Service beitreten, erhalten Sie eine 5-tägige Testversion des Programms unseres Partners. Wenn Sie ein Abonnement über den 5-tägigen Testzeitraum hinaus fortsetzen, wird Ihre Kreditkarte mit einem Betrag belastet, der je nach Tarifwahl variiert. Wenn Ihr Beitrag von Ihrer Kreditkarte oder einer anderen Zahlungsmethode abgebucht wird, haben Sie Zugriff auf diese Dienste, die ausschließlich Mitgliedern der Website unseres Partners vorbehalten sind.`,
    subtotalText: 'Zwischensumme',
    amountText: 'Zu zahlender Betrag',
    shippingText: 'Versand',
    totalText: 'Gesamt',
    freeText: 'Kostenlos',
    countryLabel: 'Land',
    country: 'Germany',
  },
  home: {
    placeholder: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'Email',
      phone: 'Telefon',
      city: 'Stadt',
      address: 'Adresse',
      zip: 'Postleitzahl',
      continue: 'Weiter',
      name: 'Der Name',
    },
    cardNumber: 'Kartennummer',
    expirationDate: 'Haltbarkeitsdatum',
    name: 'Name',
    month: 'Monat',
    year: 'Jahr',
    cvv: 'CVV',
    confirmPayment: 'Eine zahlung tätigen',
    labelNumber: 'Die Kartennummer:',
    labelMonth: 'Ablaufdatum:',
    source:
      'Wir verwenden 3D-Sicherheit, um Ihren Kauf zu verifizieren. Möglicherweise erscheint ein neues Fenster zur Transaktionsüberprüfung ',
    timer: 'Verbleibende Zeit bis zur Bezahlung der Bestellung',
  },
  validation: {
    requireEmail: 'Ihre E-Mail ist leer.',
    validEmail: 'Email ist ungültig.',
    requirePhone: 'Ihr Telefon ist leer.',
    minPhone: 'Das Telefonfeld muss aus mindestens 10 Zeichen bestehen.',
    requireFirstName: 'Der Vorname ist erforderlich.',
    validFirstName: 'Der Vorname ist ungültig',
    requireLastName: 'Das Nachname-Feld ist erforderlich.',
    validLastName: 'Das Nachname-Feld ist ungültig',
    requireCity: 'Das Stadtfeld ist erforderlich.',
    validCity: 'Das Stadtfeld ist ungültig',
    requireAddress: 'Das Adressfeld ist erforderlich.',
    validAddress: 'Das Adressfeld ist ungültig',
    requireZip: 'Das PLZ-Feld ist erforderlich.',
    validZip: 'Das PLZ-Feld ist ungültig.',
    requireCard: 'Das Feld für die Kartennummer ist erforderlich.',
    minCard: 'Nicht genug Symbole.',
    validCard: 'Das Kartennummernfeld ist ungültig.',
    requireMonth: 'Das Feld für den Verfallsmonat ist erforderlich.',
    requireYear: 'Das Feld für das Ablaufjahr ist erforderlich.',
    requireName: 'Das Namensfeld ist erforderlich.',
    validName: 'Das Namensfeld ist ungültig.',
    requireCvv: 'Das CVV-Feld ist erforderlich.',
    validCvv: 'Das CVV-Feld ist ungültig.',
    minFirstName: 'Das Vorname-Feld muss aus mindestens 3 Zeichen bestehen.',
    minLastName: 'Das Nachname-Feld muss aus mindestens 3 Zeichen bestehen.',
    minCity: 'Das Stadtfeld muss aus mindestens 3 Zeichen bestehen.',
    minAddress: 'Das Adressfeld muss aus mindestens 3 Zeichen bestehen.',
    minZip:
      'Das Feld für die Postleitzahl muss aus mindestens 3 Zeichen bestehen.',
    minName: 'Das Namensfeld muss aus mindestens 3 Zeichen bestehen.',
    minCvv: 'Das CVV-Feld muss aus mindestens 3 Zeichen bestehen.',
    specialFirstName:
      'Der Vorname des Feldes darf keine Sonderzeichen enthalten',
    specialLastName: 'Das Feld Nachname darf keine Sonderzeichen enthalten',
    specialName: 'Der Feldname darf keine Sonderzeichen enthalten',
    specialCity: 'Das Feld city darf keine Sonderzeichen enthalten',
  },
  mask: {
    phone: '+4\\9 99 999 99 99',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'GET IN TOUCH',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'E-mail',
    msg: 'Message',
    send: 'Send',
    alreadyRegistered: 'You have already registered',
    unsubscribeLink: 'unsubscribe link',
    worktime: 'Call center Works from 10 AM till 5 PM',
    phone: 'Phone: Sofia +359 2 437 4207',
  },
  footer: {
    title: 'Beteiligen Sie sich, bevor es zu spät ist',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzrichtlinie',
    contact: {
      title: 'Kontaktieren Sie uns',
      text: 'Wir sind bestrebt, jedem unserer geschätzten Kunden exzellenten Kundenservice zu bieten. Wenn Sie Fragen oder Bedenken haben, zögern Sie bitte nicht, einen unserer professionellen Kundendienstmitarbeiter zu kontaktieren',
    },
  },
};
